/**
 * Static PAD2-Site-Demo-Daten — aus dem As-Built-PDF 2024-08-29.
 * Wird in Phase 1 durch echte API-Calls /api/v1/dossier/sites/PAD2/* ersetzt.
 */

export const PAD2 = {
  code: "PAD2",
  name: "PAD2 — Horn-Bad Meinberg FC",
  country: "DE",
  business_unit: "FC",
  address: "Westfalenstr. 10, 32805 Horn-Bad Meinberg",
  coordinates: { lat: 51.89428, lon: 9.08064, source: "as-built-pdf" },
  poc_spreenauten: "Andrea Verganza (Field Engineer)",
  poc_amazon: "George (AMZL EU)",
  last_survey_at: "2024-08-29",
  operational_status: "active",

  repeaters: [
    {
      id: "PAD2-REP-01",
      role: "master",
      model: "SLR5500 UHF",
      model_number: "R10QCGANQ1AN",
      serial: "478IZN2949",
      firmware: "R20.22.01.02",
      license: "MOT Capacity Plus Single Site",
      ip: "192.168.0.11",
      udp_port: 50011,
      rest_channel_udp: 55001,
      radio_id: 1011,
      radio_name: "PAD2 ID1-2",
      rx_mhz: 450.1625,
      tx_mhz: 460.1625,
      system_code: 8,
      slot_channel_ids: [1, 2],
      pa_temp_c: 38.2,
      vswr: 1.22,
      online: true,
    },
    {
      id: "PAD2-REP-02",
      role: "peer",
      model: "SLR5500 UHF",
      model_number: "R10QCGANQ1AN",
      serial: "478IZN3027",
      firmware: "R20.22.01.02",
      license: "MOT Capacity Plus Single Site",
      ip: "192.168.0.12",
      udp_port: 50012,
      rest_channel_udp: 55001,
      radio_id: 1012,
      radio_name: "PAD2 ID3-4",
      rx_mhz: 450.2875,
      tx_mhz: 460.2875,
      system_code: 8,
      slot_channel_ids: [3, 4],
      pa_temp_c: 41.7,
      vswr: 1.31,
      online: true,
    },
    {
      id: "PAD2-REP-03",
      role: "peer",
      model: "SLR5500 UHF",
      model_number: "R10QCGANQ1AN",
      serial: "478IZN3151",
      firmware: "R20.22.01.02",
      license: "MOT Capacity Plus Single Site",
      ip: "192.168.0.13",
      udp_port: 50013,
      rest_channel_udp: 55001,
      radio_id: 1013,
      radio_name: "PAD2 ID5-6",
      rx_mhz: 450.525,
      tx_mhz: 460.525,
      system_code: 8,
      slot_channel_ids: [5, 6],
      pa_temp_c: 73.4, // <- elevated (story: offline event earlier)
      vswr: 1.18,
      online: false, // mocked offline for demo
    },
    {
      id: "PAD2-REP-04",
      role: "peer",
      model: "SLR5500 UHF",
      model_number: "R10QCGANQ1AN",
      serial: "478IZN2954",
      firmware: "R20.22.01.02",
      license: "MOT Capacity Plus Single Site",
      ip: "192.168.0.14",
      udp_port: 50014,
      rest_channel_udp: 55001,
      radio_id: 1014,
      radio_name: "PAD2 ID7-8",
      rx_mhz: 450.5375,
      tx_mhz: 460.5375,
      system_code: 8,
      slot_channel_ids: [7, 8],
      pa_temp_c: 39.1,
      vswr: 1.27,
      online: true,
    },
  ],

  antennas: {
    indoor: 33,
    outdoor: 4,
    total: 37,
  },

  frequencies: [
    {
      id: "freq-1",
      rx: 450.1625,
      tx: 460.1625,
      bandwidth_khz: 12.5,
      authority: "BNetzA",
      ref: "BNetzA-2023-DE-PAD2-A",
      valid_until: "2027-08-12",
      cost_bearer: "amazon",
      annual_cost_eur: 280,
    },
    {
      id: "freq-2",
      rx: 450.2875,
      tx: 460.2875,
      bandwidth_khz: 12.5,
      authority: "BNetzA",
      ref: "BNetzA-2023-DE-PAD2-B",
      valid_until: "2027-08-12",
      cost_bearer: "amazon",
      annual_cost_eur: 280,
    },
    {
      id: "freq-3",
      rx: 450.525,
      tx: 460.525,
      bandwidth_khz: 12.5,
      authority: "BNetzA",
      ref: "BNetzA-2023-DE-PAD2-C",
      valid_until: "2027-08-12",
      cost_bearer: "amazon",
      annual_cost_eur: 280,
    },
    {
      id: "freq-4",
      rx: 450.5375,
      tx: 460.5375,
      bandwidth_khz: 12.5,
      authority: "BNetzA",
      ref: "BNetzA-2023-DE-PAD2-D",
      valid_until: "2027-08-12",
      cost_bearer: "amazon",
      annual_cost_eur: 280,
    },
  ],

  codeplugs: [
    {
      version: "v1.4.2",
      committed_by: "uwe@spreenauten",
      committed_at: "2026-05-14",
      message: "Add Talk-Group 'Loss Prevention' to TS2",
      is_standard: true,
      is_deployed: true,
    },
    {
      version: "v1.4.1",
      committed_by: "andrea@spreenauten",
      committed_at: "2026-04-22",
      message: "Update AES key rotation",
      is_standard: false,
      is_deployed: false,
    },
    {
      version: "v1.4.0",
      committed_by: "carlos@spreenauten",
      committed_at: "2026-03-15",
      message: "Full codeplug baseline 2026 — Capacity Plus Single Site",
      is_standard: false,
      is_deployed: false,
    },
  ],

  secrets: [
    {
      label: "PAD2 Master CPS Programming Password",
      type: "programming_password",
      last_rotated_at: "2026-03-15",
      rotation_due_at: "2026-06-13",
      reveal_count: 3,
    },
    {
      label: "PAD2 AES-256 Encryption Key (TS1+TS2)",
      type: "aes_encryption_key",
      last_rotated_at: "2026-05-14",
      rotation_due_at: "2026-08-12",
      reveal_count: 1,
    },
    {
      label: "PAD2 Repeater Web-Admin Login",
      type: "web_admin_login",
      last_rotated_at: "2026-02-01",
      rotation_due_at: "2026-05-02",
      reveal_count: 8,
    },
    {
      label: "PAD2 Telnet:8501 Reset Password",
      type: "telnet_password",
      last_rotated_at: "2025-12-10",
      rotation_due_at: "2026-03-10",
      reveal_count: 0,
    },
  ],

  crew_log: [
    {
      date: "2024-08-29",
      visitor: "Andrea Verganza",
      org: "spreenauten",
      activity: "install",
      summary: "As-Built handover after full installation (4 repeaters, 37 antennas).",
      duration_hours: 8,
    },
    {
      date: "2024-12-04",
      visitor: "Uwe Stutzenberger",
      org: "spreenauten",
      activity: "maintenance",
      summary: "Firmware upgrade R20.22.01.02 across all 4 repeaters.",
      duration_hours: 3,
    },
    {
      date: "2025-06-17",
      visitor: "Carlos Comesaña",
      org: "spreenauten",
      activity: "survey",
      summary: "Annual heatmap re-survey (P1+P2+P3+P4 indoor + outdoor).",
      duration_hours: 5,
    },
    {
      date: "2026-03-15",
      visitor: "Carlos Comesaña",
      org: "spreenauten",
      activity: "maintenance",
      summary: "AES-Key rotation + Programming-Password rotation.",
      duration_hours: 2,
    },
    {
      date: "2026-05-14",
      visitor: "Uwe Stutzenberger",
      org: "spreenauten",
      activity: "maintenance",
      summary: "Codeplug v1.4.2 rollout. Loss-Prevention TG added to TS2.",
      duration_hours: 2,
    },
  ],

  documents: [
    { type: "install_pdf", name: "24-08-29-av-PAD2-DMR_System.pdf", size_kb: 4221 },
    { type: "autocad_layout", name: "24-02-15-av-PAD2-Inst_DMR.dwg", size_kb: 18943 },
    { type: "heatmap_pdf", name: "PAD2-Heatmap-P1-asBuilt.pdf", size_kb: 1184 },
    { type: "heatmap_pdf", name: "PAD2-Heatmap-P2-asBuilt.pdf", size_kb: 1102 },
    { type: "heatmap_pdf", name: "PAD2-Heatmap-P3-asBuilt.pdf", size_kb: 1132 },
    { type: "heatmap_pdf", name: "PAD2-Heatmap-P4-asBuilt.pdf", size_kb: 1097 },
    { type: "heatmap_pdf", name: "PAD2-Heatmap-Outdoor-asBuilt.pdf", size_kb: 1356 },
    { type: "frequency_certificate", name: "BNetzA-2023-DE-PAD2.pdf", size_kb: 320 },
  ],
};

export type Pad2 = typeof PAD2;
